module.exports = __webpack_public_path__ + "img/Infografis_ID_14.d3e0a340.jpg";